<div class="feature-notification">
    <div class="feature-notification__content">
        <img class="feature-notification__image" src="assets/feture-images/saved-filters.gif" alt="Feature Notification Icon">
        <h1 class="feature-notification__title">New: Fast Filters</h1>
        <p class="feature-notification__description">
            Save your filter setups and quickly change options on the fly
        </p>
    </div>
    <div class="actions">
        <!--<a mat-button class="actions__secondary" routerLink="/company" (click)="dismiss.emit()">
            Set up now
        </a>-->
        <button type="button" mat-flat-button color="accent" class="actions__primary" (click)="dismiss.emit()">
            Got it
        </button>
    </div>
</div>
